/** Account deletion requests (store requirement, docs/legal/privacy-policy.md §7). */
import { z } from "zod";
import { phone } from "./fields.js";
const note = z.string().trim().max(500).optional();
/** Public page: identify the account by its phone. The answer never reveals whether it exists. */
export const PublicDeletionRequestBody = z.object({
    phone,
    note,
    /** Honeypot: humans never fill it. */
    website: z.string().max(200).optional(),
});
/** Signed-in user asking for their own account. */
export const MyDeletionRequestBody = z.object({ note });
export const DeletionRequestStatus = z.enum(["pending", "completed", "rejected"]);
export const DeletionRequest = z.object({
    id: z.uuid(),
    organizationId: z.uuid(),
    user: z.object({
        id: z.uuid(),
        name: z.string(),
        phone: z.string().nullable(),
        status: z.enum(["active", "suspended", "archived"]),
    }),
    source: z.enum(["app", "web"]),
    note: z.string().nullable(),
    status: DeletionRequestStatus,
    createdAt: z.string(),
    decidedAt: z.string().nullable(),
    decisionNote: z.string().nullable(),
});
export const DeletionRequestsResponse = z.object({ deletionRequests: z.array(DeletionRequest) });
export const MyDeletionRequestResponse = z.object({
    /** The latest pending request, if any, so the app can show "request received". */
    pending: z.object({ createdAt: z.string() }).nullable(),
});
/** Completing suspends the account and signs it out everywhere; rejecting needs a reason. */
export const DecideDeletionRequestBody = z.discriminatedUnion("decision", [
    z.object({ decision: z.literal("complete"), note: z.string().trim().max(300).optional() }),
    z.object({ decision: z.literal("reject"), note: z.string().trim().min(3, "اذكر السبب").max(300) }),
]);
//# sourceMappingURL=privacy.js.map